'use client';

import { useWalletStore } from '@/src/store/global/index';
import { PaymentKeyHash } from '@lucid-evolution/lucid';
import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';

export const useWalletPkh = () => {
    //--------------------------------------
    const { data: session, status } = useSession();
    //--------------------------------------
    const walletStore = useWalletStore();
    //--------------------------------------
    const [userPkh, setUserPkh] = useState<PaymentKeyHash>();
    //--------------------------------------ó
    useEffect(() => {
        setUserPkh(walletStore.getPkh(true, session, status));
    }, [walletStore.isConnected, status]);
    //--------------------------------------
    return {
        userPkh,
    };
};
